var fonts = {
  default: '"Noto Sans KR", san-serif',
  accent: 'NanumSquareRound, san-serif'
};
export { fonts };